<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="title mb-1" style="color:#1271A6">Perfil Docente</span>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="dTableCceDocenteCursoPreferencia.search"
                        prepend-icon="search"
                        label="Filtrar por ..."
                        single-line
                        hide-details
                        clearable
                    ></v-text-field>
                <v-btn v-if="fuShow(['propio'])" @click="fuModalOpen()" color="primary" :loading="dLoading"><v-icon>add</v-icon> Agregar</v-btn>
            </v-card-title>
            <v-data-table 
                :headers="dTableCceDocenteCursoPreferencia.headers" 
                :items="dCceDocenteCursoPreferencias"
                :items-per-page.sync="dTableCceDocenteCursoPreferencia.itemsPerPage"
                :items-per-page-options="dTableCceDocenteCursoPreferencia.itemsPerPageOptions"
                :loading="dTableCceDocenteCursoPreferencia.loading"
                :search="dTableCceDocenteCursoPreferencia.search" class="elevation-1 zebra-table" dense>
                <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
                <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda.</v-alert></template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon v-if="fuShow(['propio'])" @click="fuDelete(item.PreferenciaId)" color="default" title="Eliminar">highlight_off</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dModal.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-form ref="refModal">
                    <v-card :loading="dModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <v-row dense>
                                <v-col cols="12" xm="6" sm="7">
                                    <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                                        :items="dPriServicios" item-value="IdServicio" item-text="Descripcion"
                                        filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']" dark></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xm="6" sm="3">
                                    <v-autocomplete v-model="dIdItinerario" label="* Itinerario"
                                        :items="dDcbItinerariosByIdServicio"  item-value="IdItinerario" item-text="Curricula"
                                        filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']" dark></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xm="6" sm="2">
                                    <v-btn :disabled="!dIdItinerario" @click.prevent="fuSearch" x-large color="primary"><v-icon>search</v-icon></v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                            <v-btn @click="dModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-container fluid>
                                <v-data-iterator
                                    item-key="IdCursoMinisterio"
                                    :items="dMatCursosMinisterios_disponible"
                                    :items-per-page.sync="dTable.itemsPerPage"
                                    :search="dTable.search"
                                >
                                    <template v-slot:header v-if="dMatCursosMinisterios_disponible.length>0">
                                        <v-row dense>
                                            <v-col cols="12" xm="6" sm="6">
                                                <v-text-field
                                                    v-model="dTable.search"
                                                    prepend-icon="search"
                                                    label="Filtrar por ..."
                                                    single-line
                                                    dense
                                                    hide-details
                                                    clearable
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" xm="6" sm="6">
                                                <v-btn :disabled="dSelectedCursos.length<=0" @click.prevent="fuSave" x-large color="success"><v-icon>save</v-icon> GUARDAR</v-btn>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                                    <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda.</v-alert></template>
                                    <template v-slot:default="props">
                                        <v-row>
                                            <v-col
                                                v-for="item in props.items"
                                                :key="item.IdCursoMinisterio"
                                                cols="12"
                                                sm="6"
                                                md="4"
                                                lg="3"
                                            >
                                                <v-card @click="fuToggleSelect(item)" 
                                                    :class="{ 'curso-seleccionado': dSelectedCursos.includes(item.IdCursoMinisterio) }"
                                                    :elevation="dSelectedCursos.includes(item.IdCursoMinisterio) ? 10 : 2"
                                                    style="cursor: pointer;"
                                                >
                                                    <v-card-text class="pa-2">
                                                        <span class="font-weight-bold">Nivel {{item.Nivel}}:</span> {{ item.Descripcion }}
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-data-iterator>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export default {
    name: 'DocenteCursoPreferencia',
    props: {
        pIdPersonal: {
            default: null,
            type: Number
        },
        pRol: {
            default: '',
            type: String
        },
    },
    mounted(){
        this.fuLoad();
        this.fuPreferencia();
    },
    watch: {
        pIdPersonal(val){
            if(val){
                this.fuPreferencia();
            }
        },
        dIdServicio(val){
            if(val){
                this.dDcbItinerariosByIdServicio = [];
                this.dIdItinerario = null;
                this.dDcbItinerariosByIdServicio = this.dDcbItinerarios.filter(item => item.IdServicio == val);
            }
        },
        dMatCursosMinisterios(val){
            if(val){
                const vIdCursoMinisterio = this.dCceDocenteCursoPreferencias.map(item => item.IdCursoMinisterio);
                this.dMatCursosMinisterios_disponible = val.filter(curso => {
                    return !vIdCursoMinisterio.includes(curso.IdCursoMinisterio);
                });
            }
        },
        dCceDocenteCursoPreferencias(val){
            if(val){
                const vIdCursoMinisterio = val.map(item => item.IdCursoMinisterio);
                this.dMatCursosMinisterios_disponible = this.dMatCursosMinisterios.filter(curso => {
                    return !vIdCursoMinisterio.includes(curso.IdCursoMinisterio);
                });
            }
        },
    },
    data: () => ({
        dSelectedCursos: [],
        dLoading: false,
        dIsUpdating: false,
        dModal: {
            title: '',
            dialog: false,
            IsUpdating: false,
        },
        dCceDocenteCursoPreferencias: [],
        dCceDocenteCursoPreferencia: {
            PreferenciaId: null,
            IdPersonal: null,
            IdCursoMinisterio: null,
        },
        dCceDocenteCursoPreferenciaDefault: {
            PreferenciaId: null,
            IdPersonal: null,
            IdCursoMinisterio: null,
        },
        dIdItinerario: null,
        dIdServicio: null,
        dPriServicios: [],
        dDcbItinerarios: [],
        dDcbItinerariosByIdServicio: [],
        dMatCursosMinisterios: [],
        dMatCursosMinisterios_disponible: [],
        dTable: {
            loading: false,
            search: null,
            itemsPerPage: 30
        },
        dTableCceDocenteCursoPreferencia: {
            headers: [
                {value: 'matcursosministerio.priservicio.Iniciales', text: 'Carrera', align: 'center'},
                {value: 'matcursosministerio.dcbitinerario.Curricula', text: 'Itinerario'},
                {value: 'matcursosministerio.Nivel', text: 'Nivel', align: 'center'},
                {value: 'matcursosministerio.Descripcion', text: 'Curso'},
                {value: 'actions', text: '...', sortable: false},
            ],
            loading: false,
            search: null,
            itemsPerPage: -1,
            itemsPerPageOptions: [5, 10, 20, 30, 50, -1],
        },
    }),
    methods: {
        async fuSave(){
            let vIdCursoCurriculas = this.dSelectedCursos.join(",");
            this.dIsUpdating = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation create($IdPersonal: Int!, $IdCursoCurriculas: String!){
                                    ccedocentecursopreferenciaCreateArray(IdPersonal:$IdPersonal, IdCursoCurriculas:$IdCursoCurriculas){
                                        error
                                        message
                                        data
                                    }
                                }`,
                    variables: {
                        IdPersonal: this.pIdPersonal,
                        IdCursoCurriculas: vIdCursoCurriculas,
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Registro correcto', 'success');
                    this.dModal.dialog = false;
                    this.fuPreferencia();
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dIsUpdating = false;
            }
        },
        fuToggleSelect(item) {
            const id = item.IdCursoMinisterio;
            const index = this.dSelectedCursos.indexOf(id);

            if (index > -1) {
                // Ya está seleccionado, lo quitamos
                this.dSelectedCursos.splice(index, 1);
            } else {
                // No está seleccionado, lo agregamos
                this.dSelectedCursos.push(id);
            }
        },
        fuShow(pArray){
            if(!this.pRol) return false;
            return pArray.includes(this.pRol);            
        },
        fuModalOpen(){
            this.dCceDocenteCursoPreferencia = { ... this.dCceDocenteCursoPreferenciaDefault };
            this.dModal.dialog = true;
        },
        async fuLoad() {
            this.dLoading = true;
            this.dPriServicios = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($Activo: Int!){
                            priservicioByActivo(Activo: $Activo){
                                IdServicio
                                Iniciales
                                Descripcion
                            }
                            dcbitinerarioByActivo(Activo: $Activo){
                                IdItinerario
                                IdServicio
                                Curricula
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        Activo: 1,
                    }
                })
                this.dDcbItinerarios = response.data.dcbitinerarioByActivo;
                this.dPriServicios = response.data.priservicioByActivo.map(servicio => ({
                    IdServicio: servicio.IdServicio,
                    Descripcion: servicio.Iniciales + ' - ' + servicio.Descripcion
                }));
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fuSearch() {
            this.dTable.loading = true;
            this.dMatCursosMinisterios = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdServicio: Int!, $IdItinerario: Int!){
                            matcursosministerioByIdServicioByIdItinerario(IdServicio: $IdServicio, IdItinerario: $IdItinerario){
                                IdCursoMinisterio
                                Descripcion
                                Nivel
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdServicio: this.dIdServicio,
                        IdItinerario: this.dIdItinerario,
                    }
                })
                this.dMatCursosMinisterios = response.data.matcursosministerioByIdServicioByIdItinerario;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false;
            }
        },
        async fuPreferencia() {
            this.dTableCceDocenteCursoPreferencia.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdPersonal: Int!){
                            ccedocentecursopreferenciaByIdPersonal(IdPersonal: $IdPersonal){
                                PreferenciaId
                                IdCursoMinisterio
                                matcursosministerio{
                                    Nivel
                                    Descripcion
                                    priservicio{
                                        Iniciales
                                        Descripcion
                                    }
                                    dcbitinerario{
                                        Curricula
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdPersonal: this.pIdPersonal,
                    }
                })
                this.dCceDocenteCursoPreferencias = response.data.ccedocentecursopreferenciaByIdPersonal;
                this.dSelectedCursos = [];
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTableCceDocenteCursoPreferencia.loading = false;
            }
        },
        fuDelete(p_PreferenciaId){
            Swal.fire({
                icon: 'question',
                title: 'Confirmación',
                html: '¿Esta seguro de Eliminar?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.$apollo.mutate({
                        mutation: gql`mutation ccedocentecursopreferenciaDelete($PreferenciaId: ID!){
                            ccedocentecursopreferenciaDelete(PreferenciaId: $PreferenciaId){
                                PreferenciaId
                            }
                        }`,
                        variables: {
                            PreferenciaId: p_PreferenciaId
                        }
                    });
                },
            }).then((result) => {
                if (result.value){
                    Swal.fire('Correcto', 'Registro eliminado', 'success');
                    this.fuPreferencia();
                }
            })
        },
    }
}
</script>
<style scoped>
.curso-seleccionado {
    border: 2px solid #1271A6 !important;
    background-color: #BBDEFB !important;
}
.zebra-table /deep/ .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    background-color: #f1f1f1 !important;
}
.zebra-table /deep/ .v-data-table__wrapper > table > tbody > tr:nth-child(even):hover {
    background-color: #e9e9e9 !important;
}
</style>
